export default __webpack_public_path__ + "static/media/pizza-dummy2.341c0327.png";